import { Tire } from '@/features/products/types/arktype/Tire';
import { TireDot } from '@/features/products/types/arktype/TireDot';
import { TireSize } from '@/features/products/types/arktype/TireSize';

type MinimalTireSize = Pick<TireSize, 'id' | 'stock' | 'price' | 'specialPrice' | 'outOfStockMessage'> & {
  tire: Pick<Tire, 'id'>[];
  tireDot: MinimalTireDot[];
};

type MinimalTireDot = Pick<TireDot, 'id' | 'yearOfManufacture' | 'stock'>;

function processTireDotField(
  tireSize: MinimalTireSize | TireSize,
  tireDot: TireDot | MinimalTireDot | undefined,
  returnType: 'tireDot',
  tireDotEnabled: boolean | undefined
): TireDot;
function processTireDotField(
  tireSize: MinimalTireSize | TireSize,
  tireDot: TireDot[] | MinimalTireDot[] | undefined,
  returnType: 'tireDot',
  tireDotEnabled: boolean | undefined
): MinimalTireDot;
function processTireDotField(
  tireSize: MinimalTireSize | TireSize,
  tireDot: TireDot[] | MinimalTireDot[] | undefined,
  returnType: 'tireDots',
  tireDotEnabled: boolean | undefined
): TireDot[];
function processTireDotField(
  tireSize: MinimalTireSize | TireSize,
  tireDot: TireDot | MinimalTireDot | MinimalTireDot[] | undefined,
  returnType: 'tireDot' | 'tireDots',
  tireDotEnabled: boolean | undefined = false
): TireDot | MinimalTireDot | TireDot[] | MinimalTireDot[] {
  if (tireDotEnabled && tireDot) return tireDot;

  const tireDotObj = {
    id: tireSize.id,
    dotCode: null,
    yearOfManufacture: new Date().getFullYear(),
    isDefault: true,
    stock: tireSize.stock!,
    price: tireSize.price!,
    specialPrice: tireSize.specialPrice!,
    outOfStockMessage: tireSize.outOfStockMessage ?? null,
  } satisfies TireDot;

  return returnType === 'tireDot' ? tireDotObj : [tireDotObj];
}

export default processTireDotField;
